import {
  Flame,
  Droplets,
  Sun,
  Snowflake,
  Zap,
  Wrench,
  type LucideIcon,
} from "lucide-react";

/**
 * Maps the default service-category ids to lucide icons. Custom categories
 * created by clients fall back to the Wrench icon.
 */
const SERVICE_ICONS: Record<string, LucideIcon> = {
  heizung: Flame,
  sanitaer: Droplets,
  solar: Sun,
  klima: Snowflake,
  elektro: Zap,
  sonstiges: Wrench,
};

export function ServiceIcon({
  id,
  className = "h-4 w-4",
}: {
  id: string;
  className?: string;
}) {
  const Icon = SERVICE_ICONS[id] ?? Wrench;
  return <Icon className={className} aria-hidden />;
}

export function serviceIconFor(id: string): LucideIcon {
  return SERVICE_ICONS[id] ?? Wrench;
}
